<md-content-box class="lesson-block" [type]="hasInvalidCategories() ? 'error' : 'default'">
	<md-icon icon="untitled-ui/general/check-circle"></md-icon>
	<div class="lesson-block__body">
		<div class="lesson-block__header">
			<div class="lesson-block__title">
				<md-header size="xs">Daily Grades</md-header>
				<span md-tooltip="Required grade" class="required">*</span>
			</div>
			<!-- Not gated on isReadOnly: the rubric explains the grade, so learners (and anyone on a locked
			     semester) may read it. The dialog is display-only. -->
			@if (perLessonCategories().length > 0) {
				<button md-button class="view-rubrics-btn" (click)="openRubricDialog()">View Rubrics</button>
			}
		</div>

		@if (gradingTemplateLoading()) {
			<lb-loader></lb-loader>
		} @else {
			<div class="lesson-block__content">
				@if (!isReadOnly()) {
					@for (category of perLessonCategories(); track category.gradingTemplateCategoryID) {
						<div class="grade-category" >
							<span class="grade-category__label">
								{{ category.categoryName }}
								<span md-tooltip="Required grade" class="required">*</span>
							</span>

							<md-drop-down
								placeholder="A+ / F"
								[dense]="true"
								[disabled]="fieldsDisabled()"
								[options]="getCategoryGradeOptions(category.categoryType)"
								[value]="categoryGrades()[category.gradingTemplateCategoryID]"
								(change)="onGradeChange(category.gradingTemplateCategoryID, $event)"
							></md-drop-down>
						</div>
					}
				} @else {
					@for (category of perLessonCategories(); track category.gradingTemplateCategoryID) {
						<div class="grade-category">
							
							<span class="grade-category__label">{{ category.categoryName }}</span>
							@let grade = getGrade(categoryGrades()[category.gradingTemplateCategoryID]);
							@if (grade) {
							<lb-grade-tag [grade]="grade.gradeName" [type]="grade?.color ?? 'default'"></lb-grade-tag>
							} @else {
								<lb-grade-tag grade="A+ / F" type="disabled"></lb-grade-tag>
							}
						</div>
					}
				}
			</div>
		}
	</div>
</md-content-box>
